
import React, { useEffect } from "react";

const WHATSAPP_ORIGIN = "http://smartlifeindia.in:8096";
const WHATSAPP_LOGIN_URL = `${WHATSAPP_ORIGIN}/login.html`;

function WhatsAppConnectPanel({
  showWhatsAppConnectPanel,
  setShowWhatsAppConnectPanel,
}) {
  useEffect(() => {
    if (!showWhatsAppConnectPanel) return;

    function handleMessage(event) {
      // Only trust messages coming from the pairing iframe itself — any page
      // could otherwise postMessage a sender number into localStorage.
      if (event.origin !== WHATSAPP_ORIGIN) return;

      // if (event?.data?.type === "WHATSAPP_CONNECTED") {
      //   alert("WhatsApp connected successfully");
      //   setShowWhatsAppConnectPanel(false);
      // }
      if (event?.data?.type === "WHATSAPP_CONNECTED") {
        const senderNumber = event.data.senderNumber;
      
        if (senderNumber) {
          localStorage.setItem(
            "WHATSAPP_SENDER_NUMBER",
            String(senderNumber).replace(/\D/g, "")
          );
        }
      
        alert("WhatsApp connected successfully");
        setShowWhatsAppConnectPanel(false);
      }
      
    }

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [showWhatsAppConnectPanel, setShowWhatsAppConnectPanel]);

  if (!showWhatsAppConnectPanel) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 70,
        left: "0%",
        width: "100%",
        height: "calc(100vh - 90px)",
        background: "#ffffff",
        borderLeft: "4px solid #198754",
        zIndex: 1001,
        display: "flex",
        flexDirection: "column",
      }}
    >
      
      <div style={{ padding: 10, borderBottom: "1px solid #ddd" }}>
        <b>Connect WhatsApp</b>
        <button
          style={{ float: "right" }}
          onClick={() => setShowWhatsAppConnectPanel(false)}
        >
          ❌
        </button>
      </div>

      <div style={{ flex: 1 }}>
        <iframe
          src={WHATSAPP_LOGIN_URL}
          title="WhatsApp Login"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </div>
    </div>
  );
}

export default WhatsAppConnectPanel;

